import axios from "axios";
import i18n from "../../i18n";

const actions = {
  proofRiskAssessment(context, { id }) {
    return axios
      .post("riskAssessment/" + id + "/proof")
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.proofedMessage")
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  rejectRiskAssessment(context, { id, reason }) {
    return axios
      .post("riskAssessment/" + id + "/reject", { reason })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.rejectedMessage")
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  getRiskAssessmentVersions(context, id) {
    return axios
      .get("riskAssessment/" + id + "/versions")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return { versions: [], currentVersion: 0, canProof: false };
      });
  },

  createRiskAssessmentImport(context, value) {
    return axios
      .post("riskAssessment/batch", value)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.import.resultMessage", {
            success: r.data.successCount,
            failed: r.data.failedCount,
          })
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  createRiskAssessment(context, value) {
    return axios
      .post("riskAssessment", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.createdMessage", { name: r.data.title })
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  bulkDeleteRiskAssessments(context, ids) {
    return axios
      .post("riskAssessment/bulk-delete", { ids })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.bulk.deletedMessage")
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  bulkProofRiskAssessments(context, ids) {
    return axios
      .post("riskAssessment/bulk-proof", { ids })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.bulk.proofedMessage", {
            proofed: r.data.proofed,
            skipped: r.data.skipped,
          })
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  bulkMoveRiskAssessments(context, { ids, riskAssessmentCategory }) {
    return axios
      .post("riskAssessment/bulk-move", { ids, riskAssessmentCategory })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.bulk.movedMessage")
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteRiskAssessment(context, val) {
    return axios
      .delete("riskAssessment/" + val.id)
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.deletedMessage")
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateRiskAssessment(context, value) {
    return axios
      .put("riskAssessment/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.updatedMessage", { name: r.data.name })
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleRiskAssessment(context, id) {
    return axios
      .get("riskAssessment/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getRiskAssessments(context, { riskAssessmentCategoryId }) {
    return axios
      .get("riskAssessment", {
        params: {
          riskAssessmentCategory: riskAssessmentCategoryId,
        },
      })
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPdfRiskAssessment(context, id) {
    return axios
      .get("riskAssessment/" + id + "/pdf")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPdfRiskAssessmentVersion(context, { id, version }) {
    return axios
      .get("riskAssessment/" + id + "/pdf/" + version)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  moveRiskAssessment(context, { id, riskAssessmentCategory }) {
    return axios
      .put(`riskAssessment/${id}`, { riskAssessmentCategory })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.movedMessage", {
            name: r.data.name,
          })
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },
};

export default actions;
